export default "__VITE_ASSET__CkXMEtEz__"